// import { RadialProgressBar } from 'components/progress-bar/js/main';
import { BaseElements, BaseObject, BaseService, BaseInjector } from "../../js/base";
import { querySelector } from '../../utility/utils';
import { focusableElements } from '../../utility/utils';

class Texts extends BaseObject {

}
class ClassList extends BaseObject {
    VISIBLE = 'back-to-top--visible';
    SNAPPED = 'back-to-top--snapped';
}

class Selectors extends BaseObject {
    backToTop = '.back-to-top';
    backToTopAction = '.back-to-top__action';
    backToTopRing = '.back-to-top__action__ring';
}

class Elements extends BaseElements<Selectors> {
    snapElement: HTMLElement;
    backToTopAction: HTMLElement;
    backToTopRing: SVGPathElement;
    isSquareAction: boolean;


    constructor(selectors: Selectors) {
        super(selectors, true);
    }

    initElements() {
        this.initElementsByLoop();
        this.isSquareAction = !!this.backToTopAction.dataset.square;
    }
}

//simple workaround to make typescript understand that these prop do exist.
interface BackToTop extends BaseService<Selectors, Elements, ClassList, Texts> { }

//Base injector requires object so it can intialized properly
@BaseInjector(Selectors, Elements, ClassList, Texts)
class BackToTop {

    // a class to snap to
    snapElementSelector: string;

    // amount of pixels to show the button after
    showAfter: number;

    // needed if the snap element is not circular
    borderLength: number;

    constructor(protected readonly wrapper: HTMLElement) { }

    initialize(): void {
        if (this.elements.backToTopAction.dataset.snap) {
            this.snapElementSelector = this.elements.backToTopAction.dataset.snap;
        }
        this.elements.snapElement = querySelector(`.${this.snapElementSelector}`);
        if (this.elements.snapElement) {
            this.elements.snapElement.style.position = 'relative';
        }
        this.showAfter = Number(this.wrapper.dataset.showAfter);

        if (this.elements.isSquareAction) {
            this.borderLength = this.elements.backToTopRing.getTotalLength() + 5;
            this.elements.backToTopRing.setAttribute(
                "stroke-dasharray",
                `${this.borderLength}, ${this.borderLength}`
            );

            this.elements.backToTopRing.setAttribute(
                "stroke-dashoffset",
                String(this.borderLength)
            );
        }
        this.addEventListeners();
    }

    addEventListeners(): void {
        this.elements.backToTopAction.addEventListener('click', this.onClick.bind(this));
        $(window).on("scroll", this.onScroll.bind(this))
    }

    onClick(event: Event): void {
        event.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        const firstFocusable: HTMLElement = document.body.querySelector(focusableElements)
        firstFocusable.focus();
    }

    onScroll(e: Event): void {
        const $thisWindow = $(e.currentTarget);
        const scrollTop = $thisWindow.scrollTop();

        if (scrollTop > this.showAfter) {
            this.wrapper.classList.add(this.classList.VISIBLE)
        } else if (scrollTop <= this.showAfter) {
            this.wrapper.classList.remove(this.classList.VISIBLE)
        }

        if (this.snapElementSelector) {
            if (this.isSnapElScrolledBy()) {
                this.wrapper.classList.add(this.classList.SNAPPED);
            } else {
                this.wrapper.classList.remove(this.classList.SNAPPED);
            }
        }
        const scroll = this.getScrollPercent()

        if (this.elements.isSquareAction) {
            const offsetToSet = (scroll / 100) * this.borderLength;
            this.elements.backToTopRing.setAttribute(
                "stroke-dashoffset", String(this.borderLength - offsetToSet)
            );
        } else {
            this.elements.backToTopRing.setAttribute('stroke-dasharray', `${this.getScrollPercent()}, 100`)
        }
    }

    /*
     * Determine if the scrolling has passed the snap element
     */
    isSnapElScrolledBy(): boolean {
        var snapEl = $(`.${this.snapElementSelector}`);
        var docViewBottom = $(window).scrollTop() + $(window).height();
        var backToTopPos = snapEl.offset().top + snapEl.height();
        return (backToTopPos <= docViewBottom);
    }

    getScrollPercent(): number {
        const h = document.documentElement;
        const b = document.body;
        const st = 'scrollTop';
        const sh = 'scrollHeight';
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
    }
}

export default BackToTop;


export {
    Elements as BackToTopElements,
    Selectors as BackToTopSelectors,
    ClassList as BackToTopClassList,
    Texts as BackToTopTexts,
}


